"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var tools_1 = require("../utils/tools");
var UNDERLINE_PATTERN = /underline/i;
var NAME = 'underline';
var toggleMarkUnderline = function (editor) {
    var format = editor.getFormat();
    var status = !Boolean(format.underline);
    editor.setFormat({ underline: status });
    return true;
};
var Underline = /** @class */ (function (_super) {
    __extends(Underline, _super);
    function Underline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'u'; };
        _this.textMatcher = [
            {
                matcher: [/\+\+([^+]+)\+\+\s$/, /~([^~]+)~\s$/]
            }
        ];
        _this.parseDOM = [
            { tag: 'ins' },
            { tag: 'u' },
            {
                tag: 'span',
                getAttrs: getAttrs
            }
        ];
        return _this;
    }
    Underline.keymap = {
        'Mod-u': toggleMarkUnderline,
        'Mod-U': toggleMarkUnderline
    };
    return Underline;
}(core_utilities_1.Inline));
exports.Underline = Underline;
function getAttrs(dom) {
    var value = dom.style.textDecorationLine || dom.style.textDecoration || '';
    var result = UNDERLINE_PATTERN.exec(value);
    if (result) {
        return true;
    }
    return false;
}
var UnderlineController = /** @class */ (function (_super) {
    __extends(UnderlineController, _super);
    function UnderlineController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'underline',
            tooltip: 'underline'
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, NAME);
        };
        return _this;
    }
    return UnderlineController;
}(core_utilities_1.SylController));
exports.UnderlineController = UnderlineController;
var UnderlinePlugin = /** @class */ (function (_super) {
    __extends(UnderlinePlugin, _super);
    function UnderlinePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = UnderlineController;
        _this.Schema = Underline;
        return _this;
    }
    return UnderlinePlugin;
}(core_utilities_1.SylPlugin));
exports.UnderlinePlugin = UnderlinePlugin;
//# sourceMappingURL=underline.js.map